import React, { useMemo } from "react";
import styled from "styled-components";
import {
  CONTENT_SECTOR_TYPE,
  ContentSectorDataType,
  ContentStoreDataType,
  ContentType,
  MainSectionType,
  WebStoreSelectorType,
} from "../../../controller/MasterController";
import StoreContent from "../content/storeContent";
import { contentName, getSectorParentName } from "../../../utils/util";
import { ThemeType } from "../../../recoil/theme";

interface SectorCategoryProps {
  storeList: WebStoreSelectorType | undefined;
  lang: number;
  currentDate: Date;
  selectedCategory: ContentSectorDataType | undefined;
  navigateSector: any;
  navigateStore: any;
  theme: ThemeType;
}

const SectorCategory = ({
  storeList,
  lang,
  currentDate,
  selectedCategory,
  navigateSector,
  navigateStore,
  theme,
}: SectorCategoryProps) => {
  const SectorCategory = useMemo(() => {
    return (
      <>
        {storeList &&
          storeList.main_section.map((main: MainSectionType, index: number) => {
            return (
              <div key={index} className="centerWrap">
                <div className="deliveryTitle">
                  <div className="row">
                    <h2>{contentName("카테고리", lang)}</h2>
                    {theme.category && <img src={theme.category} alt="box" />}
                  </div>
                </div>
                <div className="normalStoreWrap sector">
                  {main.content.map(
                    (group: ContentType, index: number) =>
                      group.content_type === CONTENT_SECTOR_TYPE && (
                        <div
                          key={index}
                          className={`sectorItem ${
                            selectedCategory &&
                            group.data.parent_store_sector_id ===
                              selectedCategory.parent_store_sector_id &&
                            "active"
                          }`}
                          onClick={() => navigateSector(group)}
                        >
                          <img
                            src={
                              group.data.sector_url
                                ? group.data.sector_url
                                : `${process.env.PUBLIC_URL}/knockknock/svg/logo.svg`
                            }
                            alt="icon"
                          />
                          <h3>{getSectorParentName(group.data, lang)}</h3>
                        </div>
                      )
                  )}
                </div>
                {selectedCategory && (
                  <>
                    <div className="line" />
                    <div className="deliveryTitle">
                      <div className="row">
                        <h2>{getSectorParentName(selectedCategory, lang)}</h2>
                        <img
                          src={
                            selectedCategory.sector_url
                              ? selectedCategory.sector_url
                              : `${process.env.PUBLIC_URL}/knockknock/svg/logo.svg`
                          }
                          alt="siren"
                        />
                      </div>
                      {/* <div className="row">
                {(currentDate.getHours() > 21 ||
                  currentDate.getHours() < 6) && (
                  <div className="timeBadge night">
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_night.svg`}
                      alt="ic"
                    />
                    {langText.storeSelector_badge_late_night[lang]}
                  </div>
                )}
                {currentDate.getHours() > 5 && currentDate.getHours() < 10 && (
                  <div className="timeBadge morning">
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_day.svg`}
                      alt="ic"
                    />
                    {langText.storeSelector_badge_breakfast[lang]}
                  </div>
                )}
              </div> */}
                    </div>
                    <div className="normalStoreWrap">
                      {selectedCategory.store_list.map(
                        (item: ContentStoreDataType, index: number) => (
                          <StoreContent
                            key={index}
                            item={{
                              content_type: "STORE",
                              data: item,
                            }}
                            currentDate={currentDate}
                            navigateSector={() =>
                              navigateStore(selectedCategory.store_list, index)
                            }
                            type={"main"}
                          />
                        )
                      )}
                    </div>
                  </>
                )}
              </div>
            );
          })}
      </>
    );
  }, [storeList, lang, selectedCategory, currentDate]);

  return SectorCategory;
};
export default SectorCategory;
